import { useEffect, useState } from 'react'

import {
  B2BSessionAuthenticateResponse,
  useStytchB2BClient
} from '@stytch/react/b2b'
import { isLocalAuthBypass } from 'lib/auth/localAuth'

// We should replace this with Stytch SDK's useStytchMemberSession()
// when Stytch have fixed the bug with it
export const useStytchSession = () => {
  const stytch = useStytchB2BClient()

  const [session, setSession] = useState<B2BSessionAuthenticateResponse | null>(
    null
  )
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    setIsLoading(true)

    if (isLocalAuthBypass()) {
      // In local mode, the stytch stub's authenticate() returns a mock
      // response immediately — no network call to Stytch servers.
      stytch.session
        .authenticate()
        .then(response => {
          setSession(response as B2BSessionAuthenticateResponse)
          setIsLoading(false)
        })
        .catch(() => {
          // Even if the stub fails, treat as authenticated in local mode
          setSession({} as B2BSessionAuthenticateResponse)
          setIsLoading(false)
        })
      return
    }

    stytch.session
      .authenticate()
      .then(response => {
        setSession(response)
        setIsLoading(false)
      })
      .catch(e => {
        setError(e as Error)
        setIsLoading(false)
      })
  }, [stytch.session])

  return { data: session, isLoading, error }
}
